import { html } from "lit-html";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { getInfoBox } from "Components/abstract/sc-e-form-field/sc-e-form-field.template";
import { getClassList } from "Helper/renderHelper/getClassList";
import { CheckableInputRenderArgs } from "Components/abstract/sc-e-checkable-form-field/sc-e-checkable-form-field.types";

import { GetRadioButtonArgs } from "./sc-e-radio-button.types";
import { ScRadioButton } from "./sc-e-radio-button";

export interface RadioButtonTemplateArgs {
  component: ScRadioButton;
}

const getLabel = (args: RadioButtonTemplateArgs) => {
  if (args.component.labelMarkup.length === 0) {
    return args.component.label;
  }

  return unsafeHTML(args.component.labelMarkup);
};

const renderInput = (args: CheckableInputRenderArgs) => {
  return html`
    <input
      type="radio"
      class="sc-e-form-field__input sc-js-form-field__input sc-e-checkable-form-field__input"
      name="${args.name}--native"
      value="${args.value}"
      id="${args.id}"
      ?required=${args.isRequired}
      ?disabled=${args.isDisabled}
      ?readonly=${args.isReadonly}
      aria-describedby="info-box-${args.id}"
      tabindex="-1"
      @change=${args.checkedCb}
    />
  `;
};

export const radioButtonTemplate = (args: RadioButtonTemplateArgs) => {
  return html`
    <label class="sc-e-checkable-form-field__content">
      ${renderInput({
        label: args.component.label,
        name: args.component.name,
        value: args.component.value,
        id: args.component.id,
        isRequired: args.component.isRequired,
        isDisabled: args.component.isDisabled,
        isReadonly: args.component.isReadonly,
        showError: args.component.state.showError,
        errorMessage: args.component.errorMessage,
        isChecked: args.component.isChecked,
        checkedCb: () => args.component.handleCheckedChange(),
      })}
      <div class="sc-e-checkable-form-field__radio-button" aria-hidden="true">
        <span class="sc-e-radio-button__state-indicator"></span>
      </div>
      <div class="sc-e-checkable-form-field__label">${getLabel(args)}</div>
    </label>
    ${getInfoBox<boolean, ScRadioButton>({
      formField: args.component,
    })}
  `;
};

export const getRadioButton = (args: GetRadioButtonArgs) => {
  return html`
    <sc-e-radio-button
      tabindex="0"
      class="${getClassList(["sc-e-radio-button", "sc-e-checkable-form-field"], args.cssClasses)}"
      label="${args.label}"
      name="${args.name}"
      value="${args.value}"
      ?required=${args.isRequired}
      ?disabled=${args.isDisabled}
      ?readonly=${args.isReadonly}
      ?checked=${args.isChecked}
      description="${args.description}"
      error-message="${args.errorMessage}"
      @sc-form-field-checked=${args.checkedCb}
    >
    </sc-e-radio-button>
  `;
};
